const CUSTOMER_KEY = 'customer-id';
const SITE_KEY = 'site-id';

export function storeCustomerIdInSessionStorage(customerId: string): void {
    sessionStorage.setItem(CUSTOMER_KEY, customerId);
}

export function storeSiteIdInSessionStorage(siteId: string): void {
    sessionStorage.setItem(SITE_KEY, siteId);
}

export function loadCustomerIdFromSessionStorage(): string | null {
    return sessionStorage.getItem(CUSTOMER_KEY);
}

export function loadSiteIdFromSessionStorage(): string | null {
    return sessionStorage.getItem(SITE_KEY);
}

export function clearCustomerAndSiteFromSessionStorage(): void {
    sessionStorage.removeItem(CUSTOMER_KEY);
    sessionStorage.removeItem(SITE_KEY);
}
